//#region Imports
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AuthenticationService } from '../../service/authentication.service'
import { Component, OnInit } from '@angular/core';
import { GenericMemberResponsePortalResponseDto } from './../../../core/models/genericMembeResponsePortalResponseDto';
import { Helper } from '@rawlings/core';
import { InactivityTimerService } from '@app/core/services/inactivity-timer.service';
import { LOGIN_VALIDATIONS, NO_SYMBOLS_OR_SPACES_PATTERN, PAGES_ROUTES, SURVEYSTEPS_INDEX, SURVEYSTEPS_NAMES } from '@app/member-response-portal/model/constants';
import { LoginDto } from '../../model/loginDto';
import { LoginResultDto } from '../../model/loginResultDto';
import { LoginService } from '../../service/login.service';
import { NavigationService } from '@app/member-response-portal/service/navigation.service';
import { NotificationRequestService } from '@app/member-response-portal/service/notification-request.service';
import { NotifierService } from '../../../core/services/notifier-service';
import { REGEX } from '@app/core/models/regex.constants';
import { SharedMemberResponseService } from '@app/member-response-portal/service/shared-member-response.service';
import { whitespaceValidator } from '@app/member-response-portal/shared/custom-validators';
//#endregion Imports
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit{
    //#region Public Variables
    public Form: FormGroup = new FormGroup({});
    public LastNameMaxLength: number = LOGIN_VALIDATIONS.LAST_NAME_MAX_LENGTH;
    public ReferenceNumberMaxLength: number = LOGIN_VALIDATIONS.REFERENCE_NUMBER_MAX_LENGTH;
    public ZipCodeMaxLength: number = LOGIN_VALIDATIONS.ZIP_CODE_MAX_LENGTH;
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    private get loginDto(): LoginDto {
        const loginDto: LoginDto = {
            ReferenceNumber: this.Form.get('referenceNumber').value,
            LastName:this.Form.get('lastName').value,
            ZipCode: this.Form.get('zipCode').value
        };
        return loginDto;
    }
    //#endregion Properties

    //#region Constructor and Angular Life Cycle

    //#region Constructor
    constructor(
        private authenticationService : AuthenticationService,
        private fb: FormBuilder,
        private inactivityTimerService: InactivityTimerService,
        private loginService : LoginService,
        private navigationService: NavigationService,
        private notificationRequestService: NotificationRequestService,
        private notifierService : NotifierService,
        private sharedMemberResponseService : SharedMemberResponseService) { }
        //#endregion Constructor

        public ngOnInit(): void {
            this.sharedMemberResponseService.DeleteSession();
            this.inactivityTimerService.StopInactivityTimerService();

            this.Form = this.fb.group({
                lastName: ['', [Validators.required, whitespaceValidator]],
                referenceNumber: ['', [Validators.required, whitespaceValidator]],
                zipCode: ['', this.validateZipCode],
            });

            const controlsToValidate: string[] = ['referenceNumber', 'lastName', 'zipCode'];
            const validators: ValidatorFn = Validators.pattern(NO_SYMBOLS_OR_SPACES_PATTERN);

            controlsToValidate.forEach((control : string) => {
                this.Form.get(control).addValidators(validators);
            });
        }
        //#region Constructor and Angular Life Cycle

        //#region Public Methods
        public OnSubmit():void{
            this.notifierService.CleanMessages();

            if(!this.Form.valid){
                this.notifierService.DisplayErrorMessage('Mandatory fields must be filled out.');
                return;
            }

            this.loginService.LoginAccess(this.loginDto)
            .subscribe((result: GenericMemberResponsePortalResponseDto<LoginResultDto>) => {
                if(result.IsSurveySubmitted || !result.Success){
                    this.notificationRequestService.ShowFailedRequestAndLogout(result);
                    return;
                }

                if (!Helper.IsEmpty(result.Data)) {
                    this.authenticationService.CreateSession(result.Data);
                    this.sharedMemberResponseService.SetQueueLetterData(result.Data.QueueLetterId, this.loginDto.ReferenceNumber);
                }

                this.sharedMemberResponseService.SetSurveyData(result.Data);
                this.RedirectTo(result.Data?.RedirectsTo);
            });
        }

        public SetErrorTooltipMessage(value: string, message: string) : string {
            if (this.Form.get(value).hasError('pattern')) {
                return `Invalid ${message}`;
            }

            return null;
        }
        //#endregion Public Methods

        //#region Private Methods
        private validateZipCode: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
            let error: ValidationErrors | null = null;

            if (Helper.IsEmpty(control) || Helper.IsEmpty(control.value)) {
                error = { requiredZipCode: 'Zip Code is required.' };
            }else{
                const isZipCodeValueValid: boolean = REGEX.ZIP_CODE.test(control.value);

                if (!isZipCodeValueValid) {
                    error = { invalidZipCode: 'Invalid Zip Code.' };
                }
            }
            return error;
        };

        private RedirectTo(url: string): void {
            if (Helper.IsEmpty(url)) {
                this.navigationService.NavigateTo(PAGES_ROUTES.CONTACT_INFORMATION);
                return;
            }

            if (!url.includes('/')) {
                this.navigationService.NavigateTo(url);
                return;
            }

            const UrlArray: string[] = url.split('/');

            const StepName: string = UrlArray[1];
            this.sharedMemberResponseService.SetActiveSurveyStepIndex(this.GetIndexBySurveyStepName(StepName));

            const UrlToRedirect: string = UrlArray[0];
            this.navigationService.NavigateTo(UrlToRedirect);
        }

        private GetIndexBySurveyStepName(stepName: string): number {
            switch (stepName) {
                case SURVEYSTEPS_NAMES.OTHER_HEALTH_INSURANCE:
                return SURVEYSTEPS_INDEX.OTHER_HEALTH_INSURANCE;

                case SURVEYSTEPS_NAMES.SOCIAL_SECURITY_BENEFIT:
                return SURVEYSTEPS_INDEX.SOCIAL_SECURITY_BENEFIT;

                case SURVEYSTEPS_NAMES.EMPLOYMENT_STATUS:
                return SURVEYSTEPS_INDEX.EMPLOYMENT_STATUS;

                case SURVEYSTEPS_NAMES.OTHER_BENEFITS:
                return SURVEYSTEPS_INDEX.OTHER_BENEFITS;

                case SURVEYSTEPS_NAMES.SUMMARY:
                return SURVEYSTEPS_INDEX.SUMMARY;

                default:
                return 0;
            }
        }
        //#region Private Methods
    }
